import React from "react";
import {
    type Cell,
    type CellTemplate,
    type Compatible,
    type UncertainCompatible,
} from "@silevis/reactgrid";
import SortRoundedIcon from "@mui/icons-material/SortRounded";
import LocalAtmRoundedIcon from "@mui/icons-material/LocalAtmRounded";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import AccessTimeRoundedIcon from "@mui/icons-material/AccessTimeRounded";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import PeopleOutlineRoundedIcon from "@mui/icons-material/PeopleOutlineRounded";
import PriceCheckIcon from "@mui/icons-material/PriceCheck";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";
import PaidOutlinedIcon from "@mui/icons-material/PaidOutlined";
import AddAlarmRoundedIcon from "@mui/icons-material/AddAlarmRounded";
import MovingRoundedIcon from "@mui/icons-material/MovingRounded";
import NoteAltOutlinedIcon from "@mui/icons-material/NoteAltOutlined";
import DirectionsRunRoundedIcon from "@mui/icons-material/DirectionsRunRounded";

export interface IconHeaderCell extends Cell {
    type: "iconHeader";
    text: string;
    iconId?: string;
}

/**
 * Maps string icon IDs to MUI icon components.
 * These IDs match the original bidColumns.jsx headerIcon assignments.
 */
const ICON_MAP: Record<string, React.ReactElement> = {
    sort: <SortRoundedIcon sx={{ fontSize: 14 }} />,
    localAtm: <LocalAtmRoundedIcon sx={{ fontSize: 14 }} />,
    localOffer: <LocalOfferOutlinedIcon sx={{ fontSize: 14 }} />,
    moving: <MovingRoundedIcon sx={{ fontSize: 14 }} />,
    accessTime: <AccessTimeRoundedIcon sx={{ fontSize: 14 }} />,
    people: <PeopleOutlineRoundedIcon sx={{ fontSize: 14 }} />,
    cart: <ShoppingCartOutlinedIcon sx={{ fontSize: 14 }} />,
    alarm: <AddAlarmRoundedIcon sx={{ fontSize: 14 }} />,
    note: <NoteAltOutlinedIcon sx={{ fontSize: 14 }} />,
    priceCheck: <PriceCheckIcon sx={{ fontSize: 14 }} />,
    payments: <PaymentsOutlinedIcon sx={{ fontSize: 14 }} />,
    paid: <PaidOutlinedIcon sx={{ fontSize: 14 }} />,
    run: <DirectionsRunRoundedIcon sx={{ fontSize: 14 }} />,
};

export class IconHeaderCellTemplate implements CellTemplate<IconHeaderCell> {
    getCompatibleCell(
        uncertainCell: UncertainCompatible<IconHeaderCell>,
    ): Compatible<IconHeaderCell> {
        const text = uncertainCell.text ?? "";
        return { ...uncertainCell, text, value: NaN };
    }

    render(cell: Compatible<IconHeaderCell>): React.ReactNode {
        const icon = cell.iconId ? ICON_MAP[cell.iconId] : null;
        return (
            <div
                style={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                    padding: "0 8px",
                    fontSize: "12px",
                    fontWeight: "bold",
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    userSelect: "none",
                }}
            >
                {icon && (
                    <span
                        style={{
                            display: "flex",
                            alignItems: "center",
                            opacity: 0.7,
                        }}
                    >
                        {icon}
                    </span>
                )}
                <span style={{ overflow: "hidden", textOverflow: "ellipsis" }}>
                    {cell.text}
                </span>
            </div>
        );
    }
}
